import * as types from './types'

export const actions = {
	toggleLoading: (payload) => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: (payload) => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	toggleLoadingSend: (payload) => ({
		type: types.TOGGLE_LOADING_SEND,
		payload,
	}),
	toggleSuccessSend: (payload) => ({
		type: types.TOGGLE_SUCCESS_SEND,
		payload,
	}),
	toggleError: (payload) => ({
		type: types.TOGGLE_ERROR,
		payload,
	}),
	setAccidents: (payload) => ({
		type: types.SET_ACCIDENTS,
		payload,
	}),
	setReportXml: (payload) => ({
		type: types.SET_REPORT_XML,
		payload,
	}),
	setAccident: (payload) => ({
		type: types.SET_ACCIDENT,
		payload,
	}),
	resetReportXml: () => ({
		type: types.RESET_REPORT_XML,
	}),

	getPerson: () => ({
		type: types.GET_PERSON,
	}),
	getPersonDone: (payload) => ({
		type: types.GET_PERSON_DONE,
		payload,
	}),
	getPersonFail: () => ({
		type: types.GET_PERSON_FAIL,
	}),

	sendSeverity: () => ({
		type: types.SEND_SEVERITY,
	}),
	sendSeverityDone: (payload) => ({
		type: types.SEND_SEVERITY_DONE,
		payload,
	}),
	sendSeverityFail: () => ({
		type: types.SEND_SEVERITY_FAIL,
	}),

	sendSeverityXml: () => ({
		type: types.SEND_SEVERITY_XML,
	}),
	sendSeverityXmlDone: (payload) => ({
		type: types.SEND_SEVERITY_XML_DONE,
		payload,
	}),
	sendSeverityXmlFail: () => ({
		type: types.SEND_SEVERITY_XML_FAIL,
	}),

	sendInvestigation: () => ({
		type: types.SEND_INVESTIGATION,
	}),
	sendInvestigationDone: (payload) => ({
		type: types.SEND_INVESTIGATION_DONE,
		payload,
	}),
	sendInvestigationFail: () => ({
		type: types.SEND_INVESTIGATION_FAIL,
	}),

	sendInvestigationXml: () => ({
		type: types.SEND_INVESTIGATION_XML,
	}),
	sendInvestigationXmlDone: (payload) => ({
		type: types.SEND_INVESTIGATION_XML_DONE,
		payload,
	}),
	sendInvestigationXmlFail: () => ({
		type: types.SEND_INVESTIGATION_XML_FAIL,
	}),

	sendComission: () => ({
		type: types.SEND_COMISSION,
	}),
	sendComissionDone: (payload) => ({
		type: types.SEND_COMISSION_DONE,
		payload,
	}),
	sendComissionFail: () => ({
		type: types.SEND_COMISSION_FAIL,
	}),

	sendComissionXml: () => ({
		type: types.SEND_COMISSION_XML,
	}),
	sendComissionXmlDone: (payload) => ({
		type: types.SEND_COMISSION_XML_DONE,
		payload,
	}),
	sendComissionXmlFail: () => ({
		type: types.SEND_COMISSION_XML_FAIL,
	}),

	getInvestigationReport: () => ({
		type: types.GET_INVESTIGATION_REPORT,
	}),
	getInvestigationReportDone: (payload) => ({
		type: types.GET_INVESTIGATION_REPORT_DONE,
		payload,
	}),
	getInvestigationReportFail: () => ({
		type: types.GET_INVESTIGATION_REPORT_FAIL,
	}),

	getFillingAct: () => ({
		type: types.GET_FILLING_ACT,
	}),
	getFillingActDone: (payload) => ({
		type: types.GET_FILLING_ACT_DONE,
		payload,
	}),
	getFillingActFail: () => ({
		type: types.GET_FILLING_ACT_FAIL,
	}),

	sendFillingAct: () => ({
		type: types.SEND_FILLING_ACT,
	}),
	sendFillingActDone: (payload) => ({
		type: types.SEND_FILLING_ACT_DONE,
		payload,
	}),
	sendFillingActFail: () => ({
		type: types.SEND_FILLING_ACT_FAIL,
	}),

	sendFillingActXml: () => ({
		type: types.SEND_FILLING_ACT_XML,
	}),
	sendFillingActXmlDone: (payload) => ({
		type: types.SEND_FILLING_ACT_XML_DONE,
		payload,
	}),
	sendFillingActXmlFail: () => ({
		type: types.SEND_FILLING_ACT_XML_FAIL,
	}),

	getActRepresentative: () => ({
		type: types.GET_ACT_REPRESENTATIVE,
	}),
	getActRepresentativeDone: (payload) => ({
		type: types.GET_ACT_REPRESENTATIVE_DONE,
		payload,
	}),
	getActRepresentativeFail: () => ({
		type: types.GET_ACT_REPRESENTATIVE_FAIL,
	}),

	sendActRepresentative: () => ({
		type: types.SEND_ACT_REPRESENTATIVE,
	}),
	sendActRepresentativeDone: (payload) => ({
		type: types.SEND_ACT_REPRESENTATIVE_DONE,
		payload,
	}),
	sendActRepresentativeFail: () => ({
		type: types.SEND_ACT_REPRESENTATIVE_FAIL,
	}),

	sendActRepresentativeXml: () => ({
		type: types.SEND_ACT_REPRESENTATIVE_XML,
	}),
	sendActRepresentativeXmlDone: (payload) => ({
		type: types.SEND_ACT_REPRESENTATIVE_XML_DONE,
		payload,
	}),
	sendActRepresentativeXmlFail: () => ({
		type: types.SEND_ACT_REPRESENTATIVE_XML_FAIL,
	}),


	recallFillingAct: () => ({
		type: types.RECALL_FILLING_ACT,
	}),
	recallFillingActDone: (payload) => ({
		type: types.RECALL_FILLING_ACT_DONE,
		payload,
	}),
	recallFillingActFail: () => ({
		type: types.RECALL_FILLING_ACT_FAIL,
	}),
}
